import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, TrendingUp, Mail, DollarSign } from 'lucide-react';
import { Button } from '../../components/ui/Button';
export function ChristmasPalace2() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="w-full pt-24 pb-24 bg-engage-black min-h-screen" data-id="element-196">
      <div className="max-w-6xl mx-auto px-4" data-id="element-197">
        {/* Back Link */}
        <Link to="/case-studies" className="inline-flex items-center text-engage-gray4 hover:text-engage-yellow transition-colors mb-12 font-medium" data-id="element-198">
          <ArrowLeft className="w-4 h-4 mr-2" data-id="element-199" />
          Back to Case Studies
        </Link>

        {/* Hero */}
        <div className="mb-16 max-w-4xl" data-id="element-200">
          <div className="flex flex-wrap gap-3 mb-6" data-id="element-201">
            <span className="px-4 py-1.5 bg-engage-yellow/10 text-engage-yellow border border-engage-yellow/20 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-202">
              The Engage Machine
            </span>
            <span className="px-4 py-1.5 bg-engage-gray2 text-engage-gray5 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-203">
              Paid Media
            </span>
            <span className="px-4 py-1.5 bg-engage-gray2 text-engage-gray5 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-204">
              Website CRO
            </span>
            <span className="px-4 py-1.5 bg-engage-gray2 text-engage-gray5 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-205">
              Social Media
            </span>
            <span className="px-4 py-1.5 bg-engage-gray2 text-engage-gray5 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-206">
              Email Marketing
            </span>
          </div>
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-black text-engage-white tracking-tight mb-4" data-id="element-207">
            The Christmas Palace
          </h1>
          <h2 className="text-2xl md:text-3xl text-engage-gray4 font-medium leading-tight" data-id="element-208">
            How we grew a milllion dollar business online store 56% in one
            season
          </h2>
        </div>

        {/* Key Results Stats */}
        <div className="mb-16" data-id="element-209">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-210">
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 relative overflow-hidden group hover:border-engage-yellow/50 transition-colors" data-id="element-211">
              <div className="absolute top-0 right-0 p-6 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-212">
                <TrendingUp className="w-24 h-24 text-engage-yellow" data-id="element-213" />
              </div>
              <div className="relative z-10 flex flex-col h-full justify-between" data-id="element-214">
                <div className="w-12 h-12 bg-engage-black border border-engage-gray2 rounded-xl flex items-center justify-center mb-6" data-id="element-215">
                  <TrendingUp className="w-6 h-6 text-engage-yellow" data-id="element-216" />
                </div>
                <div data-id="element-217">
                  <div className="text-4xl md:text-5xl font-black text-engage-white mb-2 tracking-tight" data-id="element-218">
                    +56%
                  </div>
                  <div className="text-engage-gray4 font-medium uppercase tracking-wider text-sm" data-id="element-219">
                    Revenue Growth
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 relative overflow-hidden group hover:border-engage-yellow/50 transition-colors" data-id="element-220">
              <div className="absolute top-0 right-0 p-6 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-221">
                <Mail className="w-24 h-24 text-engage-yellow" data-id="element-222" />
              </div>
              <div className="relative z-10 flex flex-col h-full justify-between" data-id="element-223">
                <div className="w-12 h-12 bg-engage-black border border-engage-gray2 rounded-xl flex items-center justify-center mb-6" data-id="element-224">
                  <Mail className="w-6 h-6 text-engage-yellow" data-id="element-225" />
                </div>
                <div data-id="element-226">
                  <div className="text-4xl md:text-5xl font-black text-engage-white mb-2 tracking-tight" data-id="element-227">
                    +102%
                  </div>
                  <div className="text-engage-gray4 font-medium uppercase tracking-wider text-sm" data-id="element-228">
                    Email Revenue Growth
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 relative overflow-hidden group hover:border-engage-yellow/50 transition-colors" data-id="element-229">
              <div className="absolute top-0 right-0 p-6 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-230">
                <DollarSign className="w-24 h-24 text-engage-yellow" data-id="element-231" />
              </div>
              <div className="relative z-10 flex flex-col h-full justify-between" data-id="element-232">
                <div className="w-12 h-12 bg-engage-black border border-engage-gray2 rounded-xl flex items-center justify-center mb-6" data-id="element-233">
                  <DollarSign className="w-6 h-6 text-engage-yellow" data-id="element-234" />
                </div>
                <div data-id="element-235">
                  <div className="text-4xl md:text-5xl font-black text-engage-white mb-2 tracking-tight" data-id="element-236">
                    5.08x
                  </div>
                  <div className="text-engage-gray4 font-medium uppercase tracking-wider text-sm" data-id="element-237">
                    ROAS
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Content Sections */}
        <div className="space-y-10" data-id="element-238">
          {/* The Challenge */}
          <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 md:p-12" data-id="element-239">
            <h3 className="text-2xl md:text-3xl font-bold text-engage-white mb-3" data-id="element-240">
              The Challenge
            </h3>
            <div className="w-16 h-1 bg-engage-yellow rounded-full mb-6" data-id="element-241" />
            <p className="text-engage-gray4 text-base md:text-lg leading-relaxed" data-id="element-242">
              A premium brand with strong demand{'\u2014'}but a fragile growth
              model. The Christmas Palace relied heavily on discounts and
              peak-season spikes to drive revenue, leaving little control over
              performance the rest of the year. Limited creative output and
              underdeveloped channels like SMS and B2B restricted scalability,
              turning growth into a reactive process instead of a predictable
              system.
            </p>
          </div>

          {/* Our Approach & The Result */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-243">
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 md:p-10 relative overflow-hidden" data-id="element-244">
              <div className="absolute top-0 right-0 w-40 h-40 bg-[radial-gradient(circle_at_top_right,rgba(252,198,13,0.12)_0%,transparent_70%)]" data-id="element-245" />
              <div className="relative z-10" data-id="element-246">
                <h3 className="text-2xl md:text-3xl font-bold text-engage-white mb-3" data-id="element-247">
                  Our Approach
                </h3>
                <div className="w-16 h-1 bg-engage-yellow rounded-full mb-6" data-id="element-248" />
                <p className="text-engage-gray4 text-base md:text-lg leading-relaxed" data-id="element-249">
                  We engineered a performance-driven ecosystem designed for
                  scale. By massively increasing creative production,
                  restructuring paid media, and activating email, SMS, and B2B
                  as core revenue drivers, we created a system that could
                  continuously generate, capture, and convert demand. Every
                  layer{'\u2014'}from traffic to conversion{'\u2014'}was
                  optimized to work together, not in isolation.
                </p>
              </div>
            </div>
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 md:p-10 relative overflow-hidden" data-id="element-250">
              <div className="absolute top-0 right-0 w-40 h-40 bg-[radial-gradient(circle_at_top_right,rgba(252,198,13,0.12)_0%,transparent_70%)]" data-id="element-251" />
              <div className="relative z-10" data-id="element-252">
                <h3 className="text-2xl md:text-3xl font-bold text-engage-white mb-3" data-id="element-253">
                  The Result
                </h3>
                <div className="w-16 h-1 bg-engage-yellow rounded-full mb-6" data-id="element-254" />
                <p className="text-engage-gray4 text-base md:text-lg leading-relaxed" data-id="element-255">
                  The business evolved from seasonal spikes into a scalable year
                  round revenue engine, achieving a 5.08 ROAS, +56% net sales
                  growth, +102% email revenue growth, and +1,919% SMS growth.
                  Revenue became more predictable, margins improved, and
                  reliance on discounts dropped, turning a reactive model into a
                  controlled and repeatable system for consistent growth.
                </p>
              </div>
            </div>
          </div>

          {/* Testimonial */}
          <div className="bg-engage-gray1 border border-engage-gray2 p-10 md:p-16 lg:p-20 rounded-2xl relative overflow-hidden text-center" data-id="element-256">
            <div className="flex justify-center mb-8" data-id="element-257">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" className="text-engage-yellow" data-id="element-258">
                <path d="M14.017 21L16.411 14.182C16.411 14.182 15.045 14.182 15.045 10.773C15.045 7.36364 18.006 5 21 5C23.994 5 24 7.36364 24 7.36364C24 7.36364 22.634 7.36364 22.634 10.773C22.634 14.182 19.909 21 19.909 21H14.017ZM3.017 21L5.411 14.182C5.411 14.182 4.045 14.182 4.045 10.773C4.045 7.36364 7.006 5 10 5C12.994 5 13 7.36364 13 7.36364C13 7.36364 11.634 7.36364 11.634 10.773C11.634 14.182 8.909 21 8.909 21H3.017Z" data-id="element-259" />
              </svg>
            </div>
            <blockquote className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-medium italic text-engage-white mb-10 md:mb-12 leading-relaxed relative z-10 max-w-4xl mx-auto" data-id="element-260">
              We didn't just scale revenue{'\u2014'}we built a system that
              generates it, with less reliance on discounts and more control
              over growth.
            </blockquote>
            <div className="flex flex-col items-center relative z-10" data-id="element-261">
              <img src="https://cdn.magicpatterns.com/uploads/8gwvPSjtFihytPMh9DLH8q/The_Christmas_Palace-CS.png" alt="The Christmas Palace" className="w-16 h-16 md:w-20 md:h-20 rounded-full mb-4 border-2 border-engage-gray2 object-cover" data-id="element-262" />
              <div className="font-bold text-engage-white text-lg" data-id="element-263">
                The Christmas Palace Team
              </div>
              <div className="text-engage-yellow font-medium text-sm uppercase tracking-wider" data-id="element-264">
                CEO, The Christmas Palace
              </div>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="mt-20 text-center bg-engage-gray1 border border-engage-gray2 rounded-2xl p-12 md:p-20 relative overflow-hidden" data-id="element-265">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(252,198,13,0.08)_0%,transparent_100%)]" data-id="element-266" />
          <div className="relative z-10 max-w-4xl mx-auto" data-id="element-267">
            <h2 className="text-3xl md:text-5xl font-black mb-6 tracking-tight" data-id="element-268">
              Ready to Build Your Growth Engine?
            </h2>
            <p className="text-engage-gray4 text-xl mb-10" data-id="element-269">
              Stop guessing with your marketing budget. Let's build a
              predictable system for your brand.
            </p>
            <Button to="/contact" variant="primary" className="text-lg px-12 py-5" data-id="element-270">
              Book a Call With Us
            </Button>
          </div>
        </div>
      </div>
    </div>;
}